import constants from '../constants'
import Dispatcher from '../dispatcher'

const Actions = {
  startApp: () => {
    Dispatcher.handleAppAction({
      type: constants.START_APP
    })
  },
  pixiStageReady: (app) => {
    Dispatcher.handleAppAction({
      type: constants.PIXI_STAGE_READY,
      item: app
    })
  },
  setLanguage: (id) => {
    Dispatcher.handleAppAction({
      type: constants.SET_LANGUAGE,
      item: id
    })
  },
  setVersion: (id) => {
    Dispatcher.handleAppAction({
      type: constants.SET_VERSION,
      item: id
    })
  },
  addChild: (child) => {
    Dispatcher.handleAppAction({
      type: constants.ADD_CHILD,
      item: { child }
    })
  },
  removeChild: (child) => {
    Dispatcher.handleAppAction({
      type: constants.REMOVE_CHILD,
      item: { child }
    })
  },
  launchVideo: (id, lang) => {
    Dispatcher.handleAppAction({
      type: constants.LAUNCH_VIDEO,
      item: {video: id, lang}
    })
  },
  closeVideo: () => {
    Dispatcher.handleAppAction({
      type: constants.CLOSE_VIDEO
    })
  },
  openMenu: () => {
    Dispatcher.handleAppAction({
      type: constants.OPEN_MENU
    })
  },
  closeMenu: () => {
    Dispatcher.handleAppAction({
      type: constants.CLOSE_MENU
    })
  },
  openLookbook: () => {
    Dispatcher.handleAppAction({
      type: constants.OPEN_LOOKBOOK
    })
  },
  closeLookbook: () => {
    Dispatcher.handleAppAction({
      type: constants.CLOSE_LOOKBOOK
    })
  },
  changeSlide: (id) => {
    Dispatcher.handleAppAction({
      type: constants.CHANGE_SLIDE,
      item: id
    })
  },
  updateStory: (id) => {
    Dispatcher.handleAppAction({
      type: constants.UPDATE_STORY,
      item: id
    })
  },
  routeUpdated: (item) => {
    Dispatcher.handleAppAction({
      type: constants.ROUTE_UPDATED,
      item
    })
  }
}

export default Actions
